<template>
  <div>
    <div class="btn-group">
      <div>
        <el-button
          class="form-btn"
          type="primary"
          @click.native.prevent="create"
        >
          新增
        </el-button>
        <a
          class="el-button el-button--primary el-button--small button--link"
          href="http://customer.yunlizhi.cn/#/seekWarehouses"
          target="_blank"
        >
          进入云仓
        </a>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="list"
      border
      highlight-current-row
    >
      <el-table-column
        type="index"
        width="50"
      />
      <el-table-column
        v-for="item in TABLECOLUMN"
        :key="item.props"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        :fixed="item.fixed"
        :min-width="item.minWidth"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'action'">
            <el-button
              type="text"
              @click.native.prevent="toEdite(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              v-if="scope.row.enabled"
              type="text"
              @click.native.prevent="enable(scope.row)"
            >
              禁用
            </el-button>
            <el-button
              v-else
              type="text"
              @click.native.prevent="enable(scope.row)"
            >
              启用
            </el-button>
            <el-button
              v-if="scope.row.enabled && !scope.row.published"
              type="text"
              @click.native.prevent="releaseToCloudWarehouse(scope.row)"
            >
              发布到云仓
            </el-button>
            <el-button
              v-if="scope.row.enabled && scope.row.published"
              type="text"
              @click.native.prevent="releaseToCloudWarehouse(scope.row)"
            >
              从云仓下架
            </el-button>
          </div>
          <div v-else-if="item.prop === 'id'">
            <el-button type="text" @click="toDeatil(scope.row)">
              {{ scope.row[item.prop] }}
            </el-button>
          </div>
          <span v-else-if="item.prop === 'attrCode'">
            {{ scope.row[item.prop] | filterAttr(store) }}
          </span>
          <span
            v-else
            v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]"
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { updateStatus, publishStatusUpdate } from '@/api/warehouse';
import {
  TABLECOLUMN, WAREHOUSE_STATUS_VALUE,
  WAREHOUSE_STATUS,
  WAREHOUSE_STATUS_NUM,
  PUBLISH_STATUS_VALUE,
} from '../constant';

export default {
  filters: {
    filterAttr(val, store) {
      const result = store.find((item) => item.code === val);
      return result && result.name;
    },
  },
  props: {
    list: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    store: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      keepPage: false,
      TABLECOLUMN,
      WAREHOUSE_STATUS_VALUE,
      WAREHOUSE_STATUS,
      WAREHOUSE_STATUS_NUM,
      PUBLISH_STATUS_VALUE,
    };
  },
  methods: {
    create() {
      this.keepPage = true;
      this.$emit('create');
    },
    toDeatil(row) {
      this.keepPage = true;
      this.$router.push({
        path: '/warehouse/detail',
        query: {
          id: row.id,
        },
      });
    },
    async releaseToCloudWarehouse(row) {
      await this.$confirm(`是否将仓库[${row.warehouseCode}]${row.published ? '从云仓下架?' : '发布到云仓?'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      });
      const data = {
        id: row.id,
        publishStatus: row.published ? PUBLISH_STATUS_VALUE.REMOVE : PUBLISH_STATUS_VALUE.PUBLISH,
      };
      await publishStatusUpdate(data);
      this.$message.success('操作成功！');
      this.$emit('fetchData');
    },
    toEdite(row) {
      this.keepPage = true;
      this.$router.push({
        path: '/warehouse/editWarehouse',
        query: {
          id: row.id,
        },
      });
    },
    enable(row) {
      updateStatus({
        id: row.id,
        enabled: !row.enabled,
      }).then(() => {
        this.$message.success(`${row.enabled ? WAREHOUSE_STATUS.DISABLED : WAREHOUSE_STATUS.DISABLED}成功！`);
        this.$emit('fetchData');
      });
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 12px;
  text-align: right;
}
.more-setting {
  margin-left: 10px;
}
.notSpecified {
  color: red;
}
.specified {
  margin-left: 10px;
}

.button--link {
  text-decoration: none;
}
</style>
